import LazyLoad from 'react-lazyload';
import TopSection from '../../../../src/components/IVF/IVFCenters/TopSection';
import BrowseCategory from '../../../../src/components/StoreHomePage/BrowseCategoryHome';
import AddedBonus from '../../StoreCategoryPage/AddedBonusSection';
import SelectYourDiaperCTA from '../../StoreCategoryPage/SelectYourDiaperCTA';
import { BannerTitle, GridWrapper } from '../BannersGrid/styled';
// import Modal3dDaiper from "../../Modal3d/Modal3dDaiper";
import BestSeller from '../BestSeller';
import BrowseAllProducts from '../BrowseAllProducts';
import ProductByCategoryGenralItem from '../ProductByCategoryGenralItem';
import StoreYTVideoSection from '../StoreYTVideoSection/StoreYTVideoSection';
import Testimonials from '../Testimonials';
import TextWidget from '../TextWidget/TextWidget';
import TimerWithCTA from '../TimerWithCTA';
import TimerWithMarquee from '../TimerWithMarquee';
import TwoColumnGrid from '../twoColumnGrid';
import BannerGeneralItemListing from './BannerGeneralItemListing';
import Timer from '../Timer';
import DisplayProduct from '../DisplayProduct/DisplayProduct';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import ClothDiaperVideoSection from '../../StoreCategoryPage/ClothDiaperVideos/ClothDiaperVideoSection';
import HereForYouSection from '../../NewStoreHomeWeb/HereForYouSection';
import BestsellerNew from '../../NewStoreHomeWeb/BestsellerNew';
import StoreHomeNew from '../../NewStoreHomeWeb/StoreHomeNew';
import NewTestimonialSection from '../NewTestimonialSection';
import ArticleCardsHome from '../ArticleCardsHome';
import OfferLockedProducts from '../../StoreCategoryPage/OfferLockedProducts';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import RelatedCategoryNavigator from '../../CategoryDetail/RelatedCategoryNavigator/RelatedCategoryNavigator';
import TopCarousel from '../TopCarousel';
import GeneralItemOfferDesign from '../../CategoryDetail/GeneralItemOfferDesign/GeneralItemOfferDesign';
import { joyfulDaysOffers } from '../../StoreCategoryPage/TopBannerwithtext/constant';
import { SnackBar } from '../../Product/PdpHeader/styled';
import CategoryGridGeneralItem from '../CategoryGridGeneraltem';
import CategoryProductFilter from '../../NewStoreHomeWeb/CategoryProductFilter';
import ProductContainer from '../../NewStoreHomeWeb/CategoryProductFilter/ProductContainer';

export default function GeneralItemListing(props) {
  const {
    data,
    setChangeCartCount,
    setShowLoader,
    offerCartData,
    setOfferCartData,
    hideStickyStrip,
    newDiaperVersion,
    clothDiaper,
    showAnimation,
    scrollUp,
    showGoTop,
    showPrice,
    setShowAnimation,
    particularElementRef,
    userType,
    fromStoreHome,
    headingText,
    setShowHeader,
    setShowTop,
    happiness,
    categoryCardsData,
    isFullScreenVideoEnabled,
    isForNewCdPage,
    lockedProductSectionRef,
    showLockedProductsAnimation,
    setShowLockedProductsAnimation,
    showB2g1Snackbar,
    productCount,
    setProductCount,
    setNonFreebieProductCount,
    nonFreebieProductCount,
    showMultipleItemsCarouselBanner,
    setIsFullScreenVideoEnabled,
    setShowFullScreenVideo,
    setCurrentVideoIndex,
    isForJoyfulPage,
    generalItems,
    showNewCDDDPage,
  } = props;
  const TwoColumnGridProps = {
    setChangeCartCount,
    offerCartData,
    setOfferCartData,
    hideStickyStrip,
    showAnimation,
  };

  const [showToast, setShowToast] = useState(false);
  const [toastValue, setToastValue] = useState('');

  const eventHandler = (data) => {
    if (data == 'copyCode') {
      setToastValue('Copied successfully');
      setShowToast(true);
    } else if (data?.offer_heading) {
      setToastValue('Apply on checkout!');
      setShowToast(true);
    } else {
      setToastValue('');
      setShowToast(false);
    }
  };

  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        setShowToast(false);
      }, 2800);
    }
  }, [showToast]);

  useEffect(() => {
    if (isForNewCdPage) {
      let count = 0;
      let nonFreebieProductCount = 0;
      const freebieProducts = Cookies?.get('b2g1_locked_products')?.split(',');
      offerCartData?.productList?.map((element) => {
        if (!element?.addToCart) {
          if (element?.quantity > 1) {
            for (let i = 1; i < element?.quantity; i++) {
              count++;
              if (!freebieProducts.includes(element.id.toString())) {
                nonFreebieProductCount++;
              }
            }
          }
          if (!freebieProducts.includes(element.id.toString())) {
            nonFreebieProductCount++;
          }
          count++;
        }
      });

      if (setProductCount) {
        setProductCount(count);
      }
      if (setNonFreebieProductCount) {
        setNonFreebieProductCount(nonFreebieProductCount);
      }
      if (
        count == 2 &&
        lockedProductSectionRef.current &&
        nonFreebieProductCount == 2
      ) {
        const element = lockedProductSectionRef.current;
        const offset = 70;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
        setShowLockedProductsAnimation(true);
        setTimeout(() => {
          setShowLockedProductsAnimation(false);
          setShowHeader('0px');
          setShowTop(true);
        }, 1000);
      } else if (nonFreebieProductCount == 1 && count > 1) {
        if (setShowAnimation) {
          document.getElementById(`twoGrid`)?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
          });
          setShowAnimation(true);
          if (!isDesktopUser()) {
            setTimeout(() => {
              setShowAnimation(false);
              setShowHeader('-56px'); // for Mweb
              setShowTop(true);
            }, 1000);
          }
        }
      }
    }
  }, [offerCartData?.productList]);

  const renderGeneralItem = (element, index) => {
    switch (element?.itemType) {
      case 'TYPE_REELS':
        return (
          <ClothDiaperVideoSection
            isFullScreenVideoEnabled={isFullScreenVideoEnabled}
            element={element}
            setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
            setShowFullScreenVideo={setShowFullScreenVideo}
            setCurrentVideoIndex={setCurrentVideoIndex}
          />
        );
      case 'WEB_USER_INTRO_PRODUCTS':
        // if (!generalItems?.length) {
        //   return null;
        // }
        const data = generalItems?.find((obj) => obj?._id == element._id);
        return (
          <ProductContainer
            data={data || element}
            isForJoyfulPage={true}
            setChangeCartCount={setChangeCartCount}
            fitHeadingImage={true}
          />
        );
      case 'MULTIPLE_ITEMS':
        switch (element?.viewType) {
          case 'CAROUSEL':
            if (
              element?.items?.[0]?.itemType == 'BANNER' &&
              showMultipleItemsCarouselBanner &&
              !element?.isTestimonialItem
            ) {
              return (
                <>
                  {element.heading ? (
                    <BannerTitle>
                      <h2>{element.heading}</h2>
                    </BannerTitle>
                  ) : null}
                  <TopCarousel
                    banner={element}
                    type={element?.viewType}
                    key={element?.itemName}
                    noMobileCategory={true}
                    tuesdayPage={true}
                    isForJoyfulPage={isForJoyfulPage}
                  />
                </>
              );
            } else if (
              element?.items?.[0]?.itemSize == 'LARGE' ||
              element?.itemSize == 'LARGE'
            ) {
              return null;
            } else {
              return (
                <Testimonials banner={element} key={index} position={index} />
              );
            }

          case 'GRID':
          case 'HORIZONTAL':
            switch (element?.items?.[0]?.itemType) {
              case 'PRODUCT':
                return element?.headingAlignment == 'TOP' ? (
                  <>
                    {clothDiaper ? (
                      <TwoColumnGrid
                        products={element}
                        userType={userType}
                        totalProducts={element?.totalCount}
                        type={'PRODUCT'}
                        showPrice={showPrice ? showPrice : true}
                        {...TwoColumnGridProps}
                        showVerticalGrid={showVerticalGrid}
                        headingText={headingText}
                        offerCartData={offerCartData}
                        isForNewCdPage={isForNewCdPage}
                      />
                    ) : (
                      <BrowseAllProducts
                        products={element}
                        totalProducts={element?.totalCount}
                        type={'PRODUCT'}
                        setChangeCartCount={setChangeCartCount}
                        setShowLoader={setShowLoader}
                        showPrice={showPrice ? showPrice : true}
                        key={index}
                        happiness={happiness}
                      />
                    )}
                  </>
                ) : (
                  <BestSeller
                    type={'PRODUCT'}
                    data={element}
                    setChangeCartCount={setChangeCartCount}
                    showPrice={showPrice ? showPrice : true}
                    key={index}
                    parentIndex={index}
                  />
                );
              case 'BANNER':
                if (element?._id == '3123') return null;
                return (
                  <BannerGeneralItemListing
                    element={element}
                    index={index}
                    showPrice={showPrice}
                    scrollUp={scrollUp}
                    showGoTop={showGoTop}
                    newDiaperVersion={newDiaperVersion}
                    happiness={happiness}
                    isForNewCdPage={isForNewCdPage}
                  />
                );
              case 'CustomBanner':
                return (
                  <GridWrapper>
                    <SelectYourDiaperCTA
                      particularRef={particularElementRef}
                      text="SELECT YOUR FAVOURITE DIAPERS"
                      setShowAnimation={setShowAnimation}
                      setShowHeader={setShowHeader}
                      setShowTop={setShowTop}
                      setShowLockedProductsAnimation={
                        setShowLockedProductsAnimation
                      }
                      productCount={productCount}
                      isForNewCdPage={isForNewCdPage}
                      lockedProductSectionRef={lockedProductSectionRef}
                      nonFreebieProductCount={nonFreebieProductCount}
                    />
                  </GridWrapper>
                );

              case 'CATEGORY':
                return (
                  <BrowseCategory
                    categoryData={element}
                    type={'CATEGORY'}
                    key={element?.itemName}
                    parentIndex={index}
                  />
                );
            }

          default:
            return <></>;
        }

      case 'HEADING_DESCRIPTION':
        return <TextWidget data={element} key={index} />;

      case 'GENERAL_TIMER_WITH_CTA':
        return <TimerWithCTA data={element} />;
      case 'GENERAL_TIMER_NEW':
        return <TimerWithMarquee data={element} />;
      case 'YOUTUBE_VIDEO':
        // return (
        if (
          typeof window != 'undefined' &&
          window.isSlowConnection &&
          window.isSlowConnection != undefined
        ) {
          return null;
        } else if (
          typeof window != 'undefined' &&
          window.isMediumConnection &&
          window.isMediumConnection != undefined
        ) {
          return (
            <LazyLoad once offset={100}>
              <StoreYTVideoSection data={element} key={index} />
            </LazyLoad>
          );
        } else {
          return (
            <LazyLoad once offset={100}>
              <StoreYTVideoSection data={element} key={index} />
            </LazyLoad>
          );
        }
      // );
      case 'FORM_FIELDS':
        return (
          <TopSection
            bannerImage={element?.sectionBgImage}
            element={element}
            isGeneralItem={true}
            index={index}
          />
        );

      case 'CUSTOM_TEXT':
        return <AddedBonus element={element} index={index} />;

      /**Type To show Categories only in a Grid View of 3X like in app Store home */
      case 'CATEGORIES_FOR_YOU':
        return (
          <CategoryGridGeneralItem
            data={element}
            isForJoyfulPage={isForJoyfulPage}
          />
        );
      case 'CATEGORIES_FOR_BABY':
        return (
          <ProductByCategoryGenralItem
            data={element}
            type={'CATEGORIES_FOR_BABY'}
          />
        );
      case 'GENERAL_TIMER_WITH_CTA':
        return <Timer data={element} productData={{}} />;

      // case "3d_DAIPER":
      //     return <Modal3dDaiper clothDiaper={true} />;
      case 'STRECH_MARKS':
        return <DisplayProduct />;
      case 'WEB_MYLO_PROMISE':
        return <HereForYouSection />;
      case 'TAB_PRODUCT_FILTERS': {
        // if (!generalItems?.length) {
        //   return null;
        // }
        const data = generalItems?.find((obj) => obj?._id == element._id);
        return (
          <BestsellerNew
            setChangeCartCount={setChangeCartCount}
            categoryData={data || element}
          />
        );
      }

      case 'CATEGORY_PRODUCT_FILTERS':
        return (
          <CategoryProductFilter
            setChangeCartCount={setChangeCartCount}
            categoryData={element}
            isForJoyfulPage={isForJoyfulPage}
            showNewProductVideoCardUx={true}
          />
        );
      case 'WEB_MYLO_CARE_BABY_CARD':
        return <StoreHomeNew categoryCardsData={categoryCardsData} />;
      // case "EXPERT_DOCTOR_SLOT":
      //     return <ExpertSectionHome />;
      case 'WEBM_REELS_WITH_PRODUCT':
        return (
          <ClothDiaperVideoSection
            element={element}
            store={true}
            currentIndex={index}
          />
        );
      case 'TESTIMONIALS_SLOT':
        return <NewTestimonialSection />;
      case 'WEB_MULTIPLE_ARTICLES':
        return <ArticleCardsHome data={element} />;
      case 'OFFER_LOCKED_FREEBIE_LIST':
        return (
          <>
            <OfferLockedProducts
              lockedProductSectionRef={lockedProductSectionRef}
              products={element}
              showVerticalGrid={false}
              showPrice={true}
              setChangeCartCount={setChangeCartCount}
              offerCartData={offerCartData}
              setOfferCartData={setOfferCartData}
              setShowAnimation={setShowAnimation}
              showLockedProductsAnimation={showLockedProductsAnimation}
              showB2g1Snackbar={showB2g1Snackbar}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              userType={userType}
              showNewCDDDPage={showNewCDDDPage}
            />
          </>
        );
      case 'L1_CATEGORY_PAGE_NAVIGATOR':
        return (
          <RelatedCategoryNavigator
            // categoryId={categoryId}
            data={element}
          />
        );
      case 'SELECTIVE_GLOBAL_COUPONS_WEB':
        return (
          <GeneralItemOfferDesign
            offerList={joyfulDaysOffers}
            horizontalOnDesktopView={true}
            eventHandler={eventHandler}
          />
        );
    }
  };

  const showVerticalGrid = clothDiaper;
  // userType === "B" && clothDiaper;
  return (
    <>
      {data?.items?.map((element, index) => {
        const item = renderGeneralItem(element, index);
        let card_id = [];
        element?.items?.map((product) => {
          card_id.push(product?._id);
        });
       

        card_id = card_id.toString().slice(0, 99);
        const dataObj = {
          category: 'impression_section_in_store_home',
          section_id: element?._id || element?.id,
          section_name: element?.heading || element?.itemName,
          shape: element?.itemType,
          deeplink_value: element?.deeplinkValue,
          card_ids: card_id,
          itemType : element?.itemType,
        };
        return (
          <ScrollWrapper
            key={`section_${index}`}
            sectionId={`section_${index}`}
            data={dataObj}
            fromStoreHome={fromStoreHome}
            clothDiaper={clothDiaper}
          >
            {item}
          </ScrollWrapper>
        );
      })}
      <SnackBar className={showToast ? 'show' : ''}>{toastValue}</SnackBar>
    </>
  );
}
